import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";
import {findIn, trigger, setAttribute, closest} from "@elements/dom-utils";

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import Tab from 'bootstrap/js/dist/tab';
onFind('[data-bs-toggle="tab"]',function (element) {
    new Tab(element);
});

import * as filterGroup from './scripts/filter-group';
filterGroup.init();

import * as productGrid from '@elements/product-grid';
productGrid.init();

import * as productGridTracking from './scripts/product-grid-tracking';
productGridTracking.init();

import * as productGridQuickFilter from '@elements/product-grid/quick-filter';
productGridQuickFilter.init();

import * as productCollapse from './scripts/product-collapse';
productCollapse.init();

import * as scrollSlider from './libs/scroll-slider/index';
scrollSlider.init({
    arrowIconClass: 'icon icon-arrow-right'
});

// import * as rangeSlider from '@elements/range-slider';
// rangeSlider.init();

import * as rangeSlider from '@elements/range-slider';
onFind('.js-range-slider', function (slider) {
    rangeSlider.createRangeSlider(slider, {
        onUpdate: (sliderObj ) => {
            if (sliderObj.handle === 1) {
                findIn('.js-range-slider__max-text', slider).innerHTML = sliderObj.value.toFixed(sliderObj.decimalPlaces);
            } else {
                findIn('.js-range-slider__min-text', slider).innerHTML = sliderObj.value.toFixed(sliderObj.decimalPlaces);
            }
        },
        onSet: (sliderObj) => {
            if (closest('.js-product-grid__submit-section', sliderObj.element) && matchMedia('(max-width: 767px)').matches) {
                findIn('.js-product-grid__submit-section-btn', closest('.js-product-grid__submit-section', sliderObj.element)).click()
            }
        }
    }, {
        slider: '.js-range-slider__slider',
        inputMin: '.js-range-slider__min',
        inputMax: '.js-range-slider__max'
    });
});

import * as dynamicModal from './scripts/dynamic-modal';
dynamicModal.init();

import * as colorChange from './scripts/color-change';
colorChange.init();

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();

import * as copyToClipboard from './scripts/copy-to-clipboard';
copyToClipboard.init();

import * as downloadList from './scripts/download-list';
downloadList.init();

import * as lightbox from '@elements/lightbox';
lightbox.init({
    plugins: ['video']
});

import * as lightboxExtend from './scripts/lightbox-extend';
lightboxExtend.init();

import Tooltip from 'bootstrap/js/dist/tooltip';
onFind('[data-bs-toggle="tooltip"]',function (element) {
    let container = 'body';

    if (closest('.modal', element)) {
        container = closest('.modal', element);
    }

    let tooltipInstance = new Tooltip(element, {
        container: container,
        trigger: element.getAttribute('data-bs-trigger') || 'click'
    });

    element.addEventListener('shown.bs.tooltip', () => {
        let target = tooltipInstance.tip

        // setAttribute('tabindex', '-1', target);
        // target.focus();

        window.addEventListener("click", function _listener(evt) {
            if (!target.contains(evt.target) && !element.contains(evt.target)) {
                window.removeEventListener("click", _listener, true);
                tooltipInstance.hide();
                // element.focus();
            }
        }, true);

        //close on esc key
        window.addEventListener("keydown", function _listener(evt) {
            if (evt.key === 'Escape') {
                window.removeEventListener("keydown", _listener, true);
                tooltipInstance.hide();
                // element.focus();
            }
        }, true);
    });
});

import * as collapseState from './scripts/collapse-state';
collapseState.init();


import * as projectWishlist from './scripts/project-wishlist';
projectWishlist.init();


import * as typeahead from './scripts/typeahead';
typeahead.init();

import * as hotspot from './scripts/hotspot';
hotspot.init();

import * as scrollVideo from './scripts/scroll-video';
scrollVideo.init();